import { render, staticRenderFns } from "./ApplyScheme.vue?vue&type=template&id=1509d578"
import script from "./ApplyScheme.vue?vue&type=script&lang=js"
export * from "./ApplyScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports